import { useMetadata } from './Metadata';

export default { plugin: useMetadata };
